module.exports = __webpack_public_path__ + "assets/0f1162d787ccfd3ac8876be573b3be90.png";